import Controller from '@ember/controller';

export default class AuthenticatedProjectsShowProjectVersionsShowBouncesController extends Controller {}
